import ApiHttp from '../http';
import MovieService from './movie-service'
import FilmFestivals from '../model/FilmVestival'
// import Observable from '../util/observazble'
// import Order from '../model/Order';
// import SeatGrid from '../model/SeatGrid'
// import Transaction from '../model/Transaction';
// import Booking from '../model/Booking';
import ModelArray from '../model/ModelArray'

class PageService {

    constructor() {
        this.news = undefined;
        this.page = [];
        this.people = undefined;
        this.cinemaPrices = undefined;
        this.competitions = undefined;
        this.event = undefined;
        this.faq = undefined;
        this.promo = undefined;
    }


    getNews(preview,id) {
        var previewLnk = preview ? '/preview/' + (preview === true ? 'all' : preview) : '';
        return this.news = this.news || ApiHttp.get(`/content/news/${id || 'all'}${previewLnk}`).then((response)=> response.data, (error)=> {
                Promise.reject(error);
                this.news = undefined
            });
    }

    getNewsArticle(id) {
        return this.getNews().then((news)=> {
            var article = news.find((newsItem)=>newsItem.general.id == id)
            if (article.related_movie) {
                article.movie = {}
                MovieService.getMovieDetail(article.related_movie).then((movie)=>article.movie = movie);
            }
            return article;
        })
    }

    getPromo(preview) {
        var previewLnk = preview ? (preview === true ? 'all' : preview) : '';
        return this.promo = this.promo ||  ApiHttp.get(`/content/promo`);
    }

    getEvent(preview){
      var previewLnk = preview ? (preview === true ? 'all' : preview) : '';
      return this.event = this.event || ApiHttp.get(`/content/event`).then((response)=> response.data, (error)=> {
        Promise.reject(error);
        this.event = undefined
      });
    }

    /**
     *
     * @returns {Promise.<FilmFestivals>|*}
     */
    getFilmFestivals() {
        return this.filmfestivals = this.filmfestivals || ApiHttp.get(`/content/film-festivals`)
                .then(
                    (response) => { return new ModelArray(response.data,FilmFestivals) },
                    (error) => {
                        this.filmfestivals = undefined;
                        return Promise.reject(error);
                    }
                )


    }

    getProcurement(preview){
      var previewLnk = preview ? (preview === true ? 'all' : preview) : '';

      //return ApiHttp.get(`/content/procurement`);

      return ApiHttp.get(`/content/procurement`);


      return this.procurement = this.procurement || ApiHttp.get(`/content/procurement`).then((response)=> response.data, (error)=> {
        Promise.reject(error);
        this.procurement = undefined
      });

    }


    getPeople(type,preview){
      var previewLnk = preview ? (preview === true ? 'all' : preview) : '';

      //return ApiHttp.get(`/content/people/`+type);

      return this.people = ApiHttp.get(`/content/people`).then((response)=> response.data, (error)=> {
        Promise.reject(error);
        this.people = undefined
      });
    }

    getGeneralPage(page_type,preview){

      var previewLnk = preview ? (preview === true ? 'all' : preview) : '';

      //return ApiHttp.get(`/content/people/`+type);

      return this.page[page_type] = this.page[page_type] ||  ApiHttp.get(`/content/generalPage/`+page_type).then((response)=> response.data, (error)=> {
        Promise.reject(error);
        this.page = undefined

      });
    }

    getPage(page_url,preview){

      var previewLnk = preview ? (preview === true ? 'all' : preview) : '';

      //return ApiHttp.get(`/content/people/`+type);

      return this.page[`url:${page_url}`] = this.page[`url:${page_url}`] ||  ApiHttp.get(`/content/page/${page_url}`).then((response)=> response.data, (error)=> {
        Promise.reject(error);
        this.page = undefined

      });
    }

    getFAQ(preview) {
        var previewLnk = preview ? (preview === true ? 'all' : preview) : '';
        return ApiHttp.get(`/content/faq`);

        return this.faq = this.faq || ApiHttp.get('/content/faq').then((response)=> response, (error)=> {
            Promise.reject(error)
            this.faq = undefined

        })        

    }

    getCinemaPrices(preview) {
        var previewLnk = preview ? (preview === true ? 'all' : preview) : '';
        return ApiHttp.get(`/content/cinemaPrices`);

        return this.cinemaPrices = this.cinemaPrices || ApiHttp.get('/content/cinemaPrices').then((response)=> response, (error)=> {
            Promise.reject(error)
            this.cinemaPrices = undefined

        })        

    }

    getCompetitions(preview) {
        var previewLnk = preview ? (preview === true ? 'all' : preview) : '';
        return ApiHttp.get(`/content/competitions`);

        return this.competitions = this.competitions || ApiHttp.get('/content/competitions').then((response)=> response, (error)=> {
            Promise.reject(error)
            this.competitions = undefined

        })        

    }

    getNode(nodeId){
        return ApiHttp.get(`/content/node/${nodeId}`).then((response)=> response.data, (error)=> { Promise.reject(error) }); }

    getContentType(type){
        return ApiHttp.get(`/content/content-type/${type}`).then((response)=> response.data, (error)=> { Promise.reject(error) }); }

}

export default new PageService();


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/service/page-service.js